<!-- //
内部iframe打开的外链（meta={link: true, linkType:''}, redirect="外链地址"）
@auth xuyd
@date 2022-11-27
//-->
<template>
  <div style="width: 100%;height: 100%">
    <iframe :src="src" class="link-iframe"></iframe>
  </div>
</template>

<script>
export default {
  name: 'Iframe',
  data() {
    return {
      src: '',
    }
  },
  computed: {},
  mounted() {
    console.log("-------Iframe mounted------>", this.$route.query);
    // 判断是否要授权
    let authentication = this.$route.query.authentication;
    let authorization = this.$store.getters.userSession.token;
    this.src = this.$route.query.src + (authentication ? `?${this.$route.query.key}=${authorization}` : '');
  }
}
</script>

<style lang="less" scoped>
.link-iframe {
  width: 100%;
  height: 100%;
  border: none;
  background-color: #fff;
}
</style>
